// Legal client state codes from Kappi.
export enum StateCode {
  scheduled = 'SCHEDULED',
  active = 'ACTIVE',
  streaming = 'STREAMING',
  overstreaming = 'OVERSTREAMING',
  finished = 'FINISHED',
  cancelled = 'CANCELLED',
  error = 'ERROR',
}

export const validBroadcastStateCodes: StateCode[] = [
  StateCode.scheduled,
  StateCode.active,
  StateCode.streaming,
  StateCode.overstreaming,
  StateCode.finished,
  StateCode.cancelled,
  StateCode.error,
];
